import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { hasDetails } from "@/api";
import { useDatasetPathDestination } from "@/composables/datasetPathDestination";
import { useDatasetStore } from "@/stores/datasetStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetLink',
    props: {
        historyDatasetId: null,
        path: null,
        label: null
    },
    setup(__props) {
        const props = __props;
        const { datasetPathDestination } = useDatasetPathDestination();
        const { getDataset } = useDatasetStore();
        const pathDestination = computed(() => datasetPathDestination.value(props.historyDatasetId, props.path));
        const dataset = computed(() => getDataset(props.historyDatasetId));
        const fileLink = computed(() => {
            if (props.path === undefined || props.path === "undefined") {
                // Download whole dataset
                if (dataset.value && hasDetails(dataset.value)) {
                    return `${dataset.value.download_url}?to_ext=${dataset.value.file_ext}`;
                }
            }
            // Download individual file from composite dataset
            return pathDestination.value?.fileLink;
        });
        const linkLabel = computed(() => {
            if (pathDestination.value?.isDirectory) {
                return `Path: ${props.path} is a directory!`;
            }
            if (!fileLink.value) {
                return `Path: ${props.path} was not found!`;
            }
            if (props.label && props.label !== "undefined") {
                return props.label;
            }
            return `${props.historyDatasetId}`;
        });
        const linkTitle = computed(() => `Download ${dataset.value?.name ?? props.historyDatasetId}`);
        return { __sfc: true, datasetPathDestination, getDataset, props, pathDestination, dataset, fileLink, linkLabel, linkTitle };
    }
});
